import React from 'react';
import { Outlet } from 'react-router-dom';
import { useReferenceData } from '../hooks/useReferenceData';

/** Routes dépendant des types administratifs chargés (comportement legacy MainMenu). */
export function RequireAdministrativeTypes() {
  const { administrativeTypes } = useReferenceData();

  if (!administrativeTypes.length) {
    return null;
  }

  return <Outlet />;
}
